import { ToggleGroup } from 'radix-ui'
import { ReactSVG } from 'react-svg'

import Checkmark from '@Assets/icons/checkmark.svg'

export type BookableCardProps = {
  id: string
  time: string
  isChecked: boolean
}

export const BookableCard = ({ id, time, isChecked }: BookableCardProps) => {
  return (
    <ToggleGroup.Item
      className={`bookable-selection-screen__card`}
      key={`${id}`}
      value={id}
      role="radio"
      aria-checked={isChecked}
      tabIndex={0}>
      <p>{time}</p>
      <div className="bookable-selection-screen__icon-container">
        <ReactSVG className={`bookable-selection-screen__icon-checkmark`} src={Checkmark} />
      </div>
    </ToggleGroup.Item>
  )
}
